import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { components } from "react-select";

export default function SortableMultiValue(props) {
  const { data } = props;

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: data.value,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <components.MultiValue {...props} />
    </div>
  );
}
